import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { CmsNavigationComponent, CmsNavigationEntry, SemanticPathService } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { ComponentService } from 'src/app/service/component.service';

export interface ShimanoCmsNavigationEntry extends CmsNavigationEntry {
  linkName: string;
  target: boolean;
  url?: string;
  contentPageLabel?: string;
  categoryCode?: string;
  productCode?: string;
}

@Component({
  selector: 'app-category-nav',
  templateUrl: './category-nav.component.html',
  styleUrls: ['./category-nav.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class CategoryNavComponent implements OnInit, OnDestroy, AfterViewInit {
  data$: Observable<CmsNavigationComponent> = this.componentData.data$;
  shimanoCategoryNavNode: any;
  showDropdown = false;
  activeI: number;
  activeIi: number;
  activeIii: number;
  showCatalogueDropdown = false;
  showSubmenu = false;
  showSubSubMenu = false;
  showSubSubSubMenu = false;
  isInsideNavbar = false;
  isDropdownActive = false;
  categoryNavSubscription$: Subscription;
  myAccountMenuSubscription$: Subscription;
  PROTOCOL_REGEX: RegExp = /^https?:\/\//i;

  constructor(
    private componentData: CmsComponentData<CmsNavigationComponent>,
    private componentService: ComponentService,
    protected semanticPathService: SemanticPathService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    // for now shimanoCategoryNavNode$ returns an error
    // Request URI Too Long
    // using data$ instead
    this.categoryNavSubscription$ = this.data$.subscribe((data) => {
      this.shimanoCategoryNavNode = data.navigationNode;
      this.cdr.detectChanges();
    });

    this.myAccountMenuSubscription$ = this.componentService.isMyAccountMenuOpen$.subscribe((isMyAccountMenuOpen) => {
      if (this.showCatalogueDropdown && isMyAccountMenuOpen) {
        this.closeCatalogueDropdown();
      }
      this.cdr.detectChanges();
    });
  }

  ngAfterViewInit() {
    this.data$.pipe(take(1)).subscribe((data) => {
      this.shimanoCategoryNavNode = data.navigationNode;
      this.cdr.detectChanges();
    });
  }

  iSChildNotEmpty(child: any, isCategory: boolean) {
    if (child.length > 0) {
      const checkEntries = child.filter((data: any) =>
        isCategory ? data.children.length > 0 : data.entries.length > 0
      ).length;

      if (checkEntries > 0) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  setShowDropdown($event: any, index: any) {
    if ($event.type === 'mouseup') {
      if (this.showDropdown && this.isInsideNavbar && this.isDropdownActive) {
        this.resetDropdown();
        return;
      }
      this.showDropdown = true;
      this.isInsideNavbar = true;
      this.isDropdownActive = true;
    }
    if ($event.type === 'mouseenter') {
      this.activeI = index;
      this.isInsideNavbar = true;
      if (this.isInsideNavbar && this.isDropdownActive) {
        this.showDropdown = true;
      }
    }
  }

  resetDropdown() {
    this.showDropdown = false;
    this.isInsideNavbar = false;
    this.isDropdownActive = false;
  }

  onClickCatalogueDropdown($event: any) {
    this.showCatalogueDropdown ? (this.showCatalogueDropdown = false) : (this.showCatalogueDropdown = true);
    this.componentService.setIsGlobalNavMobileMenuOpen(this.showCatalogueDropdown);
  }

  onClickSubMenu($event: any, index: number, url?: string) {
    $event.stopPropagation();
    if (this.isGroupsetConfiguratorLink(url)) {
      this.showCatalogueDropdown = false;
      return;
    }
    if (this.showSubmenu) {
      this.showCatalogueDropdown = true;

      if (this.showSubSubMenu && this.activeI === index) {
        this.showSubSubMenu = false;
      } else {
        this.showSubSubMenu = true;
        if (this.showSubSubSubMenu) {
          this.showSubSubSubMenu = !this.showSubSubSubMenu;
        }
      }
    } else {
      this.showSubmenu = true;
      this.showCatalogueDropdown = true;
      if (!this.activeI) {
        this.showSubSubMenu = true;
      }
    }
  }

  onClickSubSubMenu($event: any, index1: number, index2: number, index3: number) {
    $event.stopPropagation();
    if (this.showSubSubMenu) {
      this.showCatalogueDropdown = true;

      if (this.showSubSubSubMenu && this.activeI === index1 && this.activeIi === index2 && this.activeIii === index3) {
        this.showSubSubSubMenu = false;
      } else {
        this.showSubSubSubMenu = true;
      }
    } else {
      this.showSubSubMenu = true;
      this.showCatalogueDropdown = true;
      if (!this.activeIi && !this.activeIii) {
        this.showSubSubSubMenu = true;
      }
    }
  }

  closeCatalogueDropdown() {
    if (this.showCatalogueDropdown) {
      this.showCatalogueDropdown = false;
      this.componentService.setIsMyAccountMenuOpen(false);
    }
  }

  isExternalUrl(entry: ShimanoCmsNavigationEntry): boolean {
    return this.PROTOCOL_REGEX.test(entry.url);
  }

  getRouterUrl(url: any): any[] {
    if (typeof url === 'string') {
      return [this.getAbsoluteUrl(url)];
    }
    return url;
  }

  getAbsoluteUrl(url: string) {
    return url.startsWith('/') ? url : '/' + url;
  }

  getLink(entry: ShimanoCmsNavigationEntry): string | string[] {
    if (entry.contentPageLabel) {
      return this.getRouterUrl(entry.contentPageLabel);
    } else if (entry.categoryCode) {
      return this.semanticPathService.transform({
        cxRoute: 'category',
        params: {
          code: entry.categoryCode,
        },
      });
    } else if (entry.productCode) {
      return this.semanticPathService.transform({
        cxRoute: 'product',
        params: {
          code: entry.productCode,
        },
      });
    } else if (entry.url) {
      return this.getRouterUrl(entry.url);
    } else {
      return null;
    }
  }

  isGroupsetConfiguratorLink(url: string): boolean {
    return url ? url.toLowerCase().includes('search/groupset') : false;
  }

  getGroupsetRouterLink(url: string): string[] {
    return url.split('?')[0].split('/');
  }

  getGroupsetQueryParams(url: string): any {
    return { query: url.split('?')[1].split('=')[1] };
  }

  goToLink($event: any, externalUrl: string, newWindow?: boolean) {
    $event.preventDefault();
    $event.stopPropagation();
    window.open(externalUrl, newWindow ? '_blank' : '_self');
  }

  getCategoryNavHeight(): number {
    const navBar = document.getElementsByClassName('NavigationBar')[0] as HTMLElement;
    const footer = document.getElementsByClassName('Footer')[0] as HTMLElement;
    const navBarHeight = navBar.offsetTop + navBar.clientHeight;

    return footer.offsetTop - navBarHeight;
  }

  ngOnDestroy() {
    if (this.categoryNavSubscription$) {
      this.categoryNavSubscription$.unsubscribe();
    }
    if (this.myAccountMenuSubscription$) {
      this.myAccountMenuSubscription$.unsubscribe();
    }
  }
}
